/* eslint-disable no-unused-vars */
import React, { useContext, useEffect } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import DeleteIcon from '@mui/icons-material/Delete';
import { Button } from '@mui/material';
import Grid from '@mui/material/Unstable_Grid2';
import { DataGridPro } from '@mui/x-data-grid-pro';
import useTargetContext from '../context/useTargetContext';

function Table() {
  //
  const {
    auth,
    activeTab,
    targetData,
    loading,
    handleJustification,
    setRowsSelected,
    handleUpdateAll,
    finalApprover,
  } = useContext(useTargetContext);
  const actionButton =
    (activeTab === 0 && !finalApprover.includes(auth.user_id)) ||
    // (activeTab === 1 && auth.designation === 'admin')
    (activeTab === 1 && finalApprover.includes(auth.user_id))
      ? [
          {
            field: 'action',
            headerName: 'Action',
            width: 300,
            renderCell: ({ row }) => (
              <div>
                <Button
                  size='small'
                  variant='contained'
                  color='success'
                  onClick={(e) => handleJustification(row.id, 1, false)}
                  startIcon={<CheckIcon />}
                >
                  Approve
                </Button>
                &nbsp;
                <Button
                  size='small'
                  variant='contained'
                  color='error'
                  onClick={(e) => handleJustification(row.id, 3, false)}
                  startIcon={<DeleteIcon />}
                >
                  Reject
                </Button>
              </div>
            ),
          },
        ]
      : [];

  let managers;
  if (activeTab === 1) {
    managers = [
      { field: 'manager_name', flex: 1, headerName: "Manager's Name", width: 200 },
      { field: 'justification', flex: 1, headerName: "Manager's Justification", width: 200 },
    ];
  } else if (activeTab === 2) {
    managers = [
      { field: 'manager_name', flex: 1, headerName: "Manager's Name", width: 200 },
      { field: 'justification', flex: 1, headerName: "Manager's Justification", width: 200 },
      { field: 'admin_date', flex: 1, headerName: 'Date Approved (by NSM)', width: 200 },
    ];
  } else if (activeTab === 3) {
    managers = [
      { field: 'manager_name', flex: 1, headerName: "Manager's Name", width: 200 },
      { field: 'justification', flex: 1, headerName: "Manager's Justification", width: 200 },
      {
        field: 'rejected_date',
        flex: 1,
        headerName: 'Date Rejected (by NSM or Manager)',
        width: 200,
      },
    ];
  } else {
    managers = [];
  }

  const columns = [
    { field: 'requested_by', flex: 1, headerName: 'Requestor Name', width: 200 },
    { field: 'date_requested', flex: 1, headerName: 'Date Submitted', width: 200 },
    { field: 'hospital_name', flex: 1, headerName: 'Hospital Name', width: 200 },
    { field: 'point_person_name', flex: 1, headerName: 'Point Person', width: 200 },
    { field: 'point_person_designation', flex: 1, headerName: 'Designation', width: 200 },
    { field: 'current_target', headerName: 'Current Target', width: 100 },
    {
      field: 'new_target',
      headerName: 'New Target',
      width: 100,
      renderCell: ({ row }) => <div style={{ color: 'red' }}>{row.new_target}</div>,
    },
    { field: 'reason', flex: 1, headerName: 'Reason', width: 200 },
    ...managers,
    { field: 'date_from', flex: 1, headerName: 'Effective From', width: 200 },
    { field: 'date_to', flex: 1, headerName: 'Effective To', width: 200 },
    { field: 'temporary', flex: 1, headerName: 'Temporary', width: 200 },
    ...actionButton,
  ];

  return (
    <Grid container spacing={2}>
      {(activeTab === 0 && !finalApprover.includes(auth.user_id)) ||
      // (activeTab === 1 && auth.designation === 'admin') ||
      (activeTab === 1 && finalApprover.includes(auth.user_id)) ? (
        <Grid xs={12} sm={12} md={12}>
          <Button
            size='small'
            variant='contained'
            color='success'
            sx={{ float: 'right' }}
            onClick={(e) => handleJustification(null, 1, true)}
            startIcon={<CheckIcon />}
          >
            Approve All Selected
          </Button>
        </Grid>
      ) : (
        ''
      )}
      <Grid xs={12} sm={12} md={12}>
        <div className='table-container' style={{ height: '800px', marginLeft: '20px' }}>
          &nbsp;
          <DataGridPro
            rows={targetData}
            columns={columns}
            loading={loading}
            checkboxSelection
            onSelectionModelChange={(ids) => {
              const selectedIDs = new Set(ids);
              const selectedRows = targetData.filter((row) => selectedIDs.has(row.id));
              setRowsSelected(selectedRows);
            }}
          />
        </div>
      </Grid>
    </Grid>
  );
}
export default Table;
